import { useState, useEffect } from "react";
import { Button, Form } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import Auth from "../../../../component/Auth/auth";
import { AuthServices } from "../../../../component/services/auth.service";
import { useAllowedPages } from "../../../../context/AllowedPagesContext";
import "./LoginBox.css";

export default function LoginBox() {
  const navigate = useNavigate();
  const { setAllowedPages } = useAllowedPages();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    setTimeout(() => setIsVisible(true), 100);
  }, []);

  const handleLogin = async (e: any) => {
    e.preventDefault();
    await AuthServices.login({ username, password })
      .then((res) => {
        if (res.status === 200) {
          Auth.authenticate();
          localStorage.setItem("authKey", res.data.data.token);

          let allowedPages = [];
          if (
            res.data.data.allowedPages &&
            Array.isArray(res.data.data.allowedPages)
          ) {
            allowedPages = res.data.data.allowedPages;
          }
          setAllowedPages(allowedPages);

          if (allowedPages.find((page: any) => page.path === "dashboard")) {
            navigate("/dashboard");
          } else {
            navigate(
              allowedPages.length > 0
                ? "/" + allowedPages[0].path
                : "/no-access"
            );
          }
        }
      })
      .catch((err) => {
        if (err.response?.status === 403) console.error(err);
        else if (err.response?.status === 500) alert(err.response.data);
      });
  };

  return (
    <div className={`login-page ${isVisible ? "visible" : ""}`}>
      {/* Background animated gradient */}
      <div className="animated-bg"></div>

      {/* Navbar */}
      <nav className="login-navbar">
        <div className="navbar-content">
          <div className="navbar-brand">
            <svg className="brand-icon" width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
              <rect width="32" height="32" rx="8" fill="#2563eb"/>
              <path d="M8 22V10L16 6L24 10V22L16 26L8 22Z" stroke="white" strokeWidth="2" strokeLinejoin="round"/>
              <path d="M16 16L20 14V18L16 20L12 18V14L16 16Z" fill="white"/>
            </svg>
            <span className="brand-text">NIXAUTH</span>
          </div>
        </div>
      </nav>

      <div className="login-container">
        {/* Left Panel - Instructions */}
        <div className="left-panel">
          <div className="instructions-content">
            <h1 className="instructions-title">Instructions</h1>

            <div className="instruction-item">
              <span className="instruction-bullet">*</span>
              <p>Please enter your login ID and password.</p>
            </div>

            <div className="instruction-item">
              <span className="instruction-bullet">*</span>
              <p>
                You are advised <strong>not to disclose</strong> or share your password with anybody.
              </p>
            </div>

            <div className="instruction-item">
              <span className="instruction-bullet">*</span>
              <p>
                Only <strong>authorized users</strong> are allowed to proceed further.
              </p>
            </div>
          </div>
        </div>

        {/* Right Panel - Login Form */}
        <div className="right-panel">
          <div className="login-form-wrapper">
            <div className="login-header">
              <h2 className="login-title">Login</h2>
              <p className="login-subtitle">Enter your credentials to proceed</p>
            </div>

            <Form onSubmit={handleLogin} className="login-form">
              <Form.Group className="form-group">
                <Form.Label className="form-label">Username</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Enter your username"
                  value={username}
                  onChange={(e) => setUsername(e.target.value)}
                  className="form-input"
                  required
                />
              </Form.Group>

              <Form.Group className="form-group">
                <Form.Label className="form-label">Password</Form.Label>
                <Form.Control
                  type="password"
                  placeholder="••••••••"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  className="form-input"
                  required
                />
              </Form.Group>

              <Button type="submit" className="login-btn">
                Login
              </Button>
            </Form>
          </div>
        </div>
      </div>
    </div>
  );
}
